module.exports = __webpack_public_path__ + "img/turbo_on.0661e21c.svg";